module.exports = __webpack_public_path__ + "img/harts.0b8e4444.png";